import { StyleSheet } from "react-native";
import { Sizing } from "../../theme";


export const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
  },
  playerRow: {
    flexDirection: "row",
  },
  card: {
    padding: Sizing.layout.x10,
  },
  startContent: {
    justifyContent: "space-between",
    alignItems: "center",
  },
  playerImage: {
    height: Sizing.cs(200),
    width: Sizing.cs(200),
  },
  button: {},
  field: {
    alignItems: "center",
    justifyContent: "center",
  },
  fieldBody: {
    margin: Sizing.cs(20),
  },
  startButton: {
    width: "50%",
    height: Sizing.layout.x70,
    margin: Sizing.layout.x50,
    paddingBottom: Sizing.cs(10),
  },
  secretField: {
    borderStyle: "dashed",
    borderWidth: Sizing.cs(3),
    borderColor: "black",
  },
});